<template>
    <div v-if="!isLoading" class="pl-lg-4" :key="'top'+tick">
        <div class="row">
            <div v-if="isAdmin" class="col-lg-6">
                <label class="form-control-label">
                    Kunde
                    <span>*</span></label>
                <select v-model="customer"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <!-- <option value="" disabled selected>Kunde</option> -->
                    <option v-for="customer in customers" :key="customer.id" :value="customer['@id']">{{ customer.name }}
                    </option>
                </select>

            </div>
            <div v-if="customerData !== null && !isService" class="col-lg-6">
                <label class="form-control-label">
                    Benutzer
                    <span>*</span></label>
                <select v-model="profile.user"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="user in customerData.users" :key="user.id" :value="user['@id']">{{ user.email }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <base-input alternative=""
                            required
                            label="Name"
                            placeholder="Der Name des Mitarbeiters bzw. der Mitarbeiterin"
                            input-classes="form-control-alternative"
                            v-model="profile.name"
                />
            </div>
            <div class="col-lg-6">
                <label class="form-control-label">
                    Status
                    <span>*</span></label><br>
                <switches v-model="profile.isActive"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="aktiv"
                          text-disabled="inaktiv"></switches>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2">
                <label class="form-control-label">
                    Beschäftigungsart
                    <span>*</span></label>
                <select v-model="profile.employment"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-for="o in empOptions" :key="o" :value="o">{{ o }}
                    </option>
                </select>
            </div>
            <div class="col-lg-10">
                <label class="form-control-label">
                    Positionen/Aufgabenfelder
                </label>
                <b-form-tags v-model="profile.position" size="lg" add-on-change no-outer-focus class="mb-2">
                    <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
                        <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                            <li v-for="tag in tags" :key="tag" class="list-inline-item">
                                <b-form-tag
                                        @remove="removeTag(tag)"
                                        :title="tag"
                                        :disabled="disabled"
                                        variant="info"
                                >{{ tag }}</b-form-tag>
                            </li>
                        </ul>
                        <b-form-select
                                v-bind="inputAttrs"
                                v-on="inputHandlers"
                                :disabled="disabled || availableOptions.length === 0"
                                :options="availableOptions"
                        >
                            <template v-slot:first>
                                <!-- This is required to prevent bugs with Safari -->
                                <option disabled value="">Wählen Sie eine oder mehrere Aufgaben/Positionen</option>
                            </template>
                        </b-form-select>
                    </template>
                </b-form-tags>
                <label class="form-control-label mt-4">
                    Notizen
                </label>
                <textarea v-model="profile.comment" class="form-control form-control-alternative" id="userComment" rows="3" placeholder="Hier ist Platz für Ihre Notizen"></textarea>
            </div>
        </div>
        <!--- platzhalter für Schulungszertifikate
        <h2>Bitte laden Sie die notwendigen Zertifikate hoch</h2>
        <div class="row">
            <div class="col-lg-3">
                <label class="form-control-label">Root Zertifikat
                    <input class="form-control form-control-alternative"  v-bind:class="{'success':(cert.rootCert !== '')}" type="file" id="rootcertfile" ref="rcfile" v-on:change="handleFileUpload('rcf')"/>
                </label>
            </div>
            <div class="col-lg-3">
                <label class="form-control-label">Private Zertifikat
                    <input class="form-control form-control-alternative" v-bind:class="{'success':(cert.privateCert !== '')}" type="file" id="privatecertfile" ref="pcfile" v-on:change="handleFileUpload('pcf')"/>
                </label>
            </div>
            <div class="col-lg-2">
                <label class="form-control-label">Bitte hochloaden<br>
                    <base-button type="secondary" v-on:click.prevent="submitFiles()">Upload</base-button>
                </label>
            </div>
        </div> ---->
    </div>
    <div v-else class="pl-lg-4 text-center">
      <div class="spinner-container">
          <div class="spinner">
              <div class="spinner-ring"></div>
              <div class="spinner-text">Laden...</div>
          </div>
      </div>
    </div>
</template>
<script>
    import Switches from "vue-switches";
    import { BFormTags } from 'bootstrap-vue';
    export default {
        name:"profileform",
        components:{Switches,'b-form-tags': BFormTags},
        props:{
            edit:{
                type:Boolean,
                default:false,
                description:"Is edit??"
            },
        },
        data() {
            return {
                options: ['Filialleitung','Sozialkonzeptbeauftragte(r)','Servicekraft','Techniker'],
                empOptions: ['Vollzeit','Teilzeit','Geringfügig'],
                profile: {
                    user: null,
                    name: '',
                    position: [],
                    employment: '',
                    isActive: false,
                    createdAt: new Date(),
                    comment: ''
                },
                isLoading: true,
                customer: null,
                tick:1
            }
        },
        created(){
            this.tick++;
            if (!this.$store.getters['customer/isReady']) {
                this.$store.dispatch('customer/getCustomerCollection').then(() => {
                    if(!this.edit) {
                            this.customer = '/api/customers/'+this.$store.getters['authentication/customer'];
                            if (this.isService) {
                                this.profile.user = '/api/users/'+this.$store.getters['authentication/uid'];
                            }
                        }
                    this.isLoading = false
                    this.tick++;
                    }
                );
            } else {
                if(!this.edit) {
                    if (this.isService) {
                        this.profile.user = '/api/users/' + this.$store.getters['authentication/uid'];
                    }
                    this.customer = '/api/customers/'+this.$store.getters['authentication/customer'];
                }
                this.isLoading = false
                this.tick++;
            }
        },
        computed: {
            customers() {
                return this.$store.getters['customer/showCustomerCollection'];
            },
            customerData() {
                return (this.$store.getters['customer/isReady'] && this.customer !== null) ? this.$store.getters['customer/showCustomerByIRI'](this.customer) : {customer:{id:0,name: 'placeholder'}};
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isService() {
                return this.$store.getters['authentication/isService'];
            },
            availableOptions() {
                return this.options.filter(opt => this.profile.position.indexOf(opt) === -1)
            }
    }}
</script>

<style scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner-ring {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-text {
  color: #666;
  font-size: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>